import React from 'react'

export const DefaultEmailProvider: React.FC<
  React.SVGProps<SVGSVGElement>
> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" {...props}>
      <path
        d="M17.1398 19.0993C15.7294 20.0265 13.8566 21 11.1282 21C5.69472 21 0.954834 17.1987 0.954834 10.5927C0.954834 3.61589 6.20339 0 11.4288 0C16.1918 0 20.9548 3.03642 20.9548 9.03973C20.9548 12.5629 19.3132 15.5298 16.608 15.5298C15.1976 15.5298 14.2034 14.7185 13.9028 13.4669C12.8855 15.0199 11.1514 15.2517 10.2496 15.2517C7.47507 15.2517 5.76408 13.0497 5.76408 10.4536C5.76408 7.85762 7.47507 5.67881 10.4115 5.67881C11.267 5.67881 12.3074 5.86424 13.2323 6.72186V5.81788H15.7988V11.5662C15.7988 12.4702 16.0993 12.9338 16.6311 12.9338C17.6485 12.9338 18.3652 11.2649 18.3652 9.36424C18.3652 6.39735 16.608 2.64238 11.6138 2.64238C7.91437 2.64238 3.61379 4.68212 3.61379 10.5927C3.61379 16.1324 7.4057 18.543 11.1976 18.543C12.8623 18.543 14.5271 18.0795 15.8913 17.245L17.1398 19.0993ZM13.2554 10.4536C13.2554 9.01656 12.3074 7.88079 10.6658 7.88079C9.0242 7.88079 8.09934 9.01656 8.09934 10.4536C8.09934 11.9139 9.0242 13.0497 10.6658 13.0497C12.3074 13.0497 13.2554 11.9139 13.2554 10.4536Z"
        fill="inherit"
      />
    </svg>
  )
}
